import { createContext, type ReactNode, useContext } from 'react'
import type { AssetResolver } from './types'

const identityAssetResolver: AssetResolver = (source) => source
// Renderers can change asset hosts without changing shared email components.
const AssetResolverContext = createContext<AssetResolver>(identityAssetResolver)

type ResolverProps = {
    resolver?: AssetResolver
    children: ReactNode
}

export function AssetResolverProvider({
    resolver = identityAssetResolver,
    children,
}: ResolverProps) {
    return (
        <AssetResolverContext.Provider value={resolver}>{children}</AssetResolverContext.Provider>
    )
}

export function useAssetResolver() {
    return useContext(AssetResolverContext)
}
